import { useQuery } from '@apollo/react-hooks';
import GetCustomerStats from '../../../gql/get-customer-stats';

const useCustomerAnalytics = (accountId) => {
  // Use the new getCustomerStats query
  const { data, loading, error } = useQuery(GetCustomerStats, {
    variables: { accountId: accountId ? parseInt(accountId) : 0 },
    skip: !accountId || isNaN(parseInt(accountId)),
  });

  // Transform the API response to match component expectations
  if (loading) {
    return {
      loading: true,
      error: null,
      totalCustomers: 0,
      avgLifetimeValue: 0,
      avgEventsPerCustomer: 0,
      avgCustomersPerEvent: 0,
      superFans: 0,
      stats: null,
    };
  }

  if (error) {
    return {
      loading: false,
      error,
      totalCustomers: 0,
      avgLifetimeValue: 0,
      avgEventsPerCustomer: 0,
      avgCustomersPerEvent: 0,
      superFans: 0,
      stats: null,
    };
  }

  const stats = data?.getCustomerStats;

  return {
    loading: false,
    error: null,
    totalCustomers: stats?.totalCustomers?.value || 0,
    avgLifetimeValue: stats?.avgLifetimeValue?.value || 0,
    avgEventsPerCustomer: stats?.avgEventsPerCustomer?.value || 0,
    avgCustomersPerEvent: stats?.avgCustomersPerEvent?.value || 0,
    superFans: stats?.superFans?.value || 0,
    stats: stats || null,
    // Keep these for backward compatibility (can be removed if not used)
    activeUsers: Math.floor((stats?.totalCustomers?.value || 0) * 0.65),
    newThisMonth: stats?.totalCustomers?.change || 0,
    totalRevenue:
      (stats?.totalCustomers?.value || 0) *
      (stats?.avgLifetimeValue?.value || 0),
    averageOrderValue: stats?.avgLifetimeValue?.value || 0,
    topEvents: [],
    monthlyGrowth: {
      customers: stats?.totalCustomers?.change || 0,
      newUsers: 0,
      revenue: stats?.avgLifetimeValue?.change || 0,
      aov: 0,
    },
  };
};

export default useCustomerAnalytics;
